import Option from "@/Option";
import Select from "@/Select";
import { useState } from "react";

type MonthYearSelectorProps = {
  onChange: (value: any) => void;
};

const MonthYearSelector = ({ onChange }: MonthYearSelectorProps) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 2 }, (_, i) => currentYear + i);

  const emitChange = (selectedYear: number, selectedMonth: number) => {
    const formatted = `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`;
    onChange(formatted);
  };

  const handleMonthChange = (val: any) => {
    setMonth(val);
    emitChange(year, val);
  };
  const handleYearChange = (val: any) => {
    setYear(val);
    emitChange(val, month);
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      <Select
        value={month}
        defaultValue={currentMonth}
        onChange={handleMonthChange}
        label="Month"
        noLabel
      >
        {months.map((item, index) => (
          <Option key={item} value={index + 1}>
            {item}
          </Option>
        ))}
      </Select>
      <Select
        defaultValue={currentYear}
        value={year}
        onChange={handleYearChange}
        label="Year"
        noLabel
      >
        {years.map((item) => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default MonthYearSelector;
